import { IACDLEvent } from '../../../../../../__legacy__/services/eventBus.service';

export const ImportAnnotationsFinishedType = Symbol('IMPORT_ANNOTATIONS_FINISHED');

export class ImportAnnotationsFinished implements IACDLEvent {
  constructor(public readonly projectId: string) {}

  readonly type: symbol = ImportAnnotationsFinishedType;
}
